export const mapBackendToForm = (data) => {
    if (!data) return {};

    const cleanData = { ...data };

    cleanData.bloodOrders = typeof data.bloodOrders === 'string'
        ? JSON.parse(data.bloodOrders)
        : data.bloodOrders || {};
    
    cleanData.labsToDo = typeof data.labsToDo === 'string'
        ? JSON.parse(data.labsToDo)
        : data.labsToDo || [];
        
    cleanData.imagingToBeAvailable = typeof data.imagingToBeAvailable === 'string'
        ? JSON.parse(data.imagingToBeAvailable)
        : data.imagingToBeAvailable || [];

    // Ensure date fields match input type format strings (YYYY-MM-DDThh:mm)
    const datetimeFields = ['scheduledDatetime', 'lastDose'];
    datetimeFields.forEach(field => {
        if (cleanData[field]) {
            cleanData[field] = new Date(cleanData[field]).toISOString().slice(0, 16);
        }
    });

    const dateFields = ['stopDate'];
    dateFields.forEach(field => {
        if (cleanData[field]) {
            cleanData[field] = new Date(cleanData[field]).toISOString().slice(0, 10);
        }
    });

    return cleanData;
};

export const mapFormToBackend = (formData) => {
    return {
        ...formData,
        bloodOrders: JSON.stringify(formData.bloodOrders || {}),
        labsToDo: JSON.stringify(formData.labsToDo || []),
        imagingToBeAvailable: JSON.stringify(formData.imagingToBeAvailable || []),
        uhid: parseInt(formData.uhid) || 0,
        ipNumber: parseInt(formData.ipNumber) || 0,
        estimatedBloodLoss: parseInt(formData.estimatedBloodLoss) || 0,
        status: 'pending' // As in original logic
    };
};
